export function isAtradiusRefused(cover) {
  const document = cover?._doc || cover;
  if (!document) return false;
  const statuses = [document.status, document.statut, document.decisionStatus, document.totalDecision?.status, cover?.status, cover?.statut];
  if (statuses.some(value => /^(refusee?|refused|declined|rejected)$/.test(String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()))) return true;
  const value = document.totalDecision?.decisionAmtInPolicyCurrency;
  if (value === null || value === undefined || String(value).trim() === '') return false;
  return Number(String(value).replace(/\s/g, '').replace(',', '.')) === 0;
}
